import React, { Component } from "react";
import { connect } from "react-redux";
import * as todoListActions from "../../../../../../actions/todo_list/todo_list";

import Prismic from "prismic-javascript";
import { PrismicConfig } from "../../../../../../helpers/prismicHelpers/PrismicAPI";
import { LanguagePrismicHelper } from "../../../../../../helpers/prismicHelpers/PrismicHelpers";
import {
  prismicSliceHelper,
  prismicSliceContentRelationship
} from "../../../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers";
import { sliceComponentsHelper } from "../../../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers";
import Loader from "../../../../../common/elements/Loader";


const brightTalkIframe =
'<div class="jsBrightTALKEmbedWrapper" style="width:100%; height:100%; position:relative;background: #ffffff;"><script class="jsBrightTALKEmbedConfig" type="application/json">{ "channelId" : 14157, "language": "en-US", "displayMode" : "channelList", "height" : "2000" }</script><iframe width="100%" height="2000" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" class="jsPlayer" src="https://www.brighttalk.com/service/player/en-US/theme/default/channel/14157/channellist?b=55589" style="overflow: hidden;"></iframe><script src="https://www.brighttalk.com/clients/js/player-embed/player-embed.js" class="jsBrightTALKEmbed"></script></div>';

class BrightTalkWebinarsPage extends Component {
  state = {
    slices: null
  };

  async componentDidMount() {
    const personId = localStorage.getItem("person_id");
    const { updateTodoList } = this.props;
    setTimeout(() => updateTodoList(personId, 9), 120000);

    //prismic
    const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, {
      accessToken: PrismicConfig.apiAccessTokes
    });
    const json = await prismicConnection.query(
      Prismic.Predicates.at("my.flexible-layout.uid", "bright-talk-webinars"),
      LanguagePrismicHelper()
    );
    let { slices } = prismicSliceHelper(json);
    slices =
      slices && slices.length
        ? await prismicSliceContentRelationship(slices, prismicConnection)
        : null;
    this.setState({ slices });
  }

  render() {
    const { slices } = this.state;

    if (!slices) return <Loader />;

    return (
      <React.Fragment>
        {sliceComponentsHelper(slices)}

        <div className="container">
          <button
            type="button"
            className="btn btn-primary--ghost back"
            onClick={() => location.reload()}
          >
            <span className="icon">
              <i
                className="fa fa-arrow-left animated-left"
                aria-hidden="true"
              />
            </span>
            <span className="label">Refresh</span>
          </button>
          <div dangerouslySetInnerHTML={{ __html: brightTalkIframe }} />
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateTodoList: (personId, listItem) =>
      dispatch(todoListActions.updateTodoList(personId, listItem))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(BrightTalkWebinarsPage);



// WEBPACK FOOTER //
// src/client/components/site/features/training/brightTalkWebinars/pages/BrightTalkWebinarsPage.js